import { isNil } from 'lodash';

export const inPercent = (value?: number | string | null, precision = 0) =>
	!isNil(value) ? `${Number(value).toFixed(precision)}%` : null;
